<template>
  <svg id="France" xmlns="http://www.w3.org/2000/svg" width="20.0519" height="20.0519" viewBox="0 0 16.963 16.963">
    <path id="Tracé_17383" data-name="Tracé 17383" d="M3.711,0A3.711,3.711,0,0,0,0,3.711v9.542a3.711,3.711,0,0,0,3.711,3.711H5.654V0Z" fill="#163c95" />
    <path id="Tracé_17384" data-name="Tracé 17384" d="M170.667,0h0V16.963h5.654V0Z" transform="translate(-165.013)" fill="#fff" />
    <path id="Tracé_17385" data-name="Tracé 17385" d="M343.277,0h-1.944V16.963h1.944a3.711,3.711,0,0,0,3.711-3.711V3.711A3.711,3.711,0,0,0,343.277,0Z" transform="translate(-330.024)" fill="#ff4310" />
  </svg>
</template>
